/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Active_HintInputs */

const cs_templates_active_hint = /** @type {(inputs: Templates_Active_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktivní šablony vidí makléři při generování. Neaktivní zůstávají jen adminům.`)
};

const en_templates_active_hint = /** @type {(inputs: Templates_Active_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active templates are visible to brokers when generating. Inactive stay admin-only.`)
};

/**
* | output |
* | --- |
* | "Active templates are visible to brokers when generating. Inactive stay admin-only." |
*
* @param {Templates_Active_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_active_hint = /** @type {((inputs?: Templates_Active_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Active_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_active_hint(inputs)
	return cs_templates_active_hint(inputs)
});